import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ParagraphSectionheading extends Component {
  render() {
    return (
      <section className="paragraph">
        <div>
          <h2 id={this.props.content.fieldHeading.toLowerCase().replace(/\W/g, '-')} className="h2 mb-0">
            {this.props.content.fieldHeading}
          </h2>
          {!!this.props.content.fieldText &&
            <div className="text" dangerouslySetInnerHTML={{ __html: this.props.content.fieldText.value }} />
          }
        </div>
      </section>
    );
  }
}

ParagraphSectionheading.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphSectionheading;
